/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExcelColumn
 */
export interface ExcelColumn {
    /**
     * 
     * @type {string}
     * @memberof ExcelColumn
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExcelColumn
     */
    propertyName?: string | null;
}

export function ExcelColumnFromJSON(json: any): ExcelColumn {
    return ExcelColumnFromJSONTyped(json, false);
}

export function ExcelColumnFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcelColumn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'propertyName': !exists(json, 'propertyName') ? undefined : json['propertyName'],
    };
}

export function ExcelColumnToJSON(value?: ExcelColumn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'propertyName': value.propertyName,
    };
}


